import React from 'react'
import './Services.css'
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import Card from '../Card/Card';
import Resume from './resume.pdf';
import {themeContext} from '../../Context'
import { useContext } from 'react';
import {motion} from 'framer-motion'


const Services = () => {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
    const transition = {duration : 1, type: 'spring'}

  return (
    <div className="services" id='Services'>

        {/* left side */}
        <div className="awesome">
        <span style={{color: darkMode? 'white':''}}>My Awesome</span>
        <span>    Skills</span>
        <span>
            Python 101 For Data Science ( IBM Certificate ) - 2022
            <br/>
            Undergone Software Development Training in Jspiders
        </span>

        <a href={Resume} download id='dbutn'>
            <button className='button s-button' >Download CV</button>
        </a>
        
        <div className="blur s-blur1" style={{ background : "#ABF1FF94"}}></div>
        </div>

        {/* right side */}

        <div className="cards">

        <motion.div
         initial={{ left: "20rem" }}
         whileInView={{ left: "14rem" }}
         transition={transition}
        //  style={{left: '14rem'}}
            
            
            // style={{left: '14rem'}} 
            >
                <Card
                emoji = {HeartEmoji}
                heading = {'FrameWork'}
                detail = {'AngularJS, ReactJS, Django'}
                />
            </motion.div>
                        {/* Second Card */}

            <motion.div 
            initial={{ left: "-15rem", top: "12rem" }}
            whileInView={{ left: "-4rem" }}
            transition={transition}
            
            //  style={{left: '-4rem',top:"12rem"}}
            >
                <Card
                emoji = {Glasses}
                heading = {'Programming Language'}
                detail = {'Python, Java, C, Html, Css, JavaScript'}
                />
            </motion.div>
                          {/* Third Card */}

            <motion.div 
           initial={{ top: "19rem", left: "20rem" }}
           whileInView={{ left: "12rem" }}
           transition={transition}
            
            
            // style={{left: '12rem',top:"19rem"}}
            >
                <Card
                emoji = {Humble}
                heading = {'Data-Base'}
                detail = {'MySql, SqLite'}
                />
            </motion.div>
            <div className='blur s-blur2' style={{background: "var(--purple)"}}>
              
            </div>
            
        </div>
    </div>
  )
}

export default Services